export default {
  API_URL: "https://api.wafr.co/api/",
  DEV_API_URL: "https://api.wafr.co/api/",
};
